import coaMapping from "@/api/accounting/coa-mapping";

import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    loanTypes: [],
    coaCategories: [],
    transactionTypes: [],
    currencies: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_LOAN_TYPES(state, data) {
        state.loanTypes = data;
    },
    SET_TRANSACTION_TYPES(state, data) {
        state.transactionTypes = data;
    },
    SET_COA_CATEGORIES(state, data) {
        state.coaCategories = data;
    },
    SET_CURRENCIES(state, data) {
        state.currencies = data;
    },
    CLEAR_STATE(state) {
        state.loanTypes = [];
        state.coaCategories = [];
        state.transactionTypes = [];
        state.currencies = [];
    }
};

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attrubutes
        );
        return coaMapping.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return coaMapping.store(data);
    },
    update(context, { id, data }) {
        return coaMapping.update(id, data);
    },
    destroy(context, { id, data }) {
        return coaMapping.destroy(id, data);
    },
    async getLoanType(context, attributes = {}) {
        let response = await coaMapping.loanType({ params: attributes });
        context.commit("SET_LOAN_TYPES", response.data);
    },
    async getTransactionType(context, attributes = {}) {
        let response = await coaMapping.transactionType({ params: attributes });
        context.commit("SET_TRANSACTION_TYPES", response.data);
    },
    async getCurrency(context, attributes = {}) {
        let response = await coaMapping.currency({ params: attributes });
        context.commit("SET_CURRENCIES", response.data);
    },
    async getCoaCategory(context, attributes = {}) {
        let response = await coaMapping.coaCategory({ params: attributes });
        context.commit("SET_COA_CATEGORIES", response.data);
    },
    getSourceValue(context, attributes = {}) {
        return coaMapping.sourceValue({ params: attributes });
    },
    getCoaSetup(context, attributes = {}) {
        let params = Object.assign({
            filter: {
                search: attributes.search,
                acc_cat_id: attributes.acc_cat_id,
                currency_id: attributes.currency_id
            }
        });
        return coaMapping.coaSetup({ params });
    }
};
